import loadingImg from "../assets/robot-loader.gif";
export const tmpl = `<div class="sh-widget-timeline-container">
    <div class="sh-widget-loader">
        <img src="${loadingImg}" alt="Loading...">
    </div>
    <div class="sh-widget-timeline-header">
        <h3><span data-element="title"></span> <button data-sh-widget-tooltip="Daily percentage change in the total number of detections in the dataset." class="sh-widget-tooltip-button white">i</button></h3>
        <p data-element="description"></p>
    </div>
    <div class="sh-widget-timeline-graph" data-element="graph"></div>
</div>`;
